export default {
  dashboardStats: (state) => state.dashboardStats,
  statusSummary: (state) => state.statusSummary,
  periods: (state) => state.periods.data,
  periodsLoading: (state) => state.periods.loading,
  periodsTotal: (state) => state.periods.pagination.total || 0,
  currentPeriod: (state) => state.currentPeriod,
  wizard: (state) => state.wizard,
  runs: (state) => state.runs.data,
  runsLoading: (state) => state.runs.loading,
  runsTotal: (state) => state.runs.pagination.total || 0,
  currentRun: (state) => state.currentRun,
  runProgress: (state) => state.runProgress,
  pollingTimedOut: (state) => state.pollingTimedOut,
  runResults: (state) => state.runResults.data,
  runResultsTotal: (state) => state.runResults.pagination.total || 0,
  currentEntity: (state) => state.currentEntity,
  entityHistory: (state) => state.entityHistory.data,
  entityHistoryLoading: (state) => state.entityHistory.loading,
  entityHistoryTotal: (state) => state.entityHistory.total,
  entityLiveData: (state) => state.entityLiveData,
  scoreChangeRequests: (state) => state.scoreChangeRequests,
  scoreChangeDialog: (state) => state.scoreChangeDialog,
  pendingScoreChange: (state) =>
    (state.scoreChangeRequests || []).find((r) => r.status === "PENDING") ||
    null,
  resultModal: (state) => state.resultModal,
  toast: (state) => state.toast,
};
